<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <!-- Post -->
    <div
      v-if="isPremium"
      class="login-page"
    >
      <!-- Post Submission Form -->

      <ValidationObserver
        @submit.prevent="validateBeforeSubmit"
        ref="postFormObserver"
        tag="form"
      >
        <section>
          <h3>Criar Publicação</h3>
          <hr>
          <b-collapse
            :open="true"
            position="is-bottom"
            aria-id="contentIdForA11y1"
          >
            <a
              slot="trigger"
              slot-scope="props"
              aria-controls="contentIdForA11y1"
            >
              <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
              {{ !props.open ? 'Expandir' : 'Recolher' }}

            </a>
            <!-- Imagem Destaque -->
            <b-field label="Imagem de Destaque">
              <div class="column is-10 flex flex-col">
                <div>
                  <b-progress
                    v-if="performingRequest && uploadValue < 100"
                    id="progress"
                    :value="uploadValue"
                    show-value
                    format="percent"
                  ></b-progress>
                  <img
                    class="preview"
                    :src="imagePreview || post.picture || ''"
                  >
                  <div class="flex">
                    <b-upload
                      @input="previewImage"
                      accept="image/*"
                    >
                      <a class="button">
                        <span>{{post.picture ? 'Alterar...' : 'Selecionar arquivo...'}}</span>
                      </a>
                    </b-upload>
                    <div v-if="imageData!=null">
                      <a
                        @click="uploadPostPicture"
                        class="button is-primary"
                      >
                        <b-icon icon="upload"></b-icon>
                        <span>Enviar</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </b-field>

            <!-- Título -->
            <validation-provider
              rules="required|min:2|max:150"
              v-slot="{ errors }"
              name="Título"
              slim
            >
              <b-field
                label="Título"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <b-input
                  v-model="post.title"
                  placeholder="TÍTULO"
                />
              </b-field>
            </validation-provider>

            <!-- Especialidades -->
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              name="Especialidades"
              slim
            >
              <b-field
                label="Especialidades"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <b-taginput
                  v-model="post.specialties"
                  :data="filteredTags"
                  autocomplete
                  :allow-new="false"
                  maxtags="3"
                  placeholder="Adicione uma Especialidade"
                  @typing="getFilteredTags"
                >
                  <template slot-scope="props">
                    {{props.option}}
                  </template>
                </b-taginput>
              </b-field>
            </validation-provider>

            <!-- Conteúdo -->
            <validation-provider
              rules="required|min:10|max:20000"
              v-slot="{ errors }"
              name="Conteúdo"
              slim
            >
              <b-field
                label="Conteúdo"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <ckeditor
                  v-model="post.content"
                  :editor="editor"
                  :config="editorConfig"
                />
              </b-field>
            </validation-provider>
            <div class="my-4">
              <b-button
                type="is-primary"
                class="mr-4"
                native-type="submit"
              >
                {{editingPost ? 'Salvar Alterações': 'Salvar'}}
              </b-button>
              <b-button
                v-if="editingPost"
                @click="cancelEditPost"
              >
                Cancelar
              </b-button>
            </div>
          </b-collapse>
        </section>
      </ValidationObserver>

      <!-- Posts Listing -->
      <section>
        <h3>Publicações Criadas</h3>
        <hr>
        <b-collapse
          :open="true"
          position="is-bottom"
          aria-id="contentIdForA11y1"
        >
          <a
            slot="trigger"
            slot-scope="props"
            aria-controls="contentIdForA11y1"
          >
            <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
            {{ !props.open ? 'Expandir' : 'Recolher' }}

          </a>

          <!-- Paginated Table -->

          <b-table
            :data="posts"
            :paginated="true"
            :per-page="5"
            :current-page.sync="currentPage"
            :pagination-simple="false"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            class="mx-8"
          >

            <template slot-scope="props">
              <b-table-column
                field="title"
                label="Título"
                width="40"
                sortable
              >
                {{ props.row.title }}
              </b-table-column>

              <b-table-column
                field="content"
                label="Conteúdo"
                sortable
              >
                {{ props.row.content | trimLength(30) }}
              </b-table-column>

              <b-table-column
                field="createdOn"
                label="Criação"
                sortable
              >
                {{ props.row.createdOn | formatDate }}
              </b-table-column>

              <b-table-column
                field="updatedOn"
                label="Atualização"
                sortable
                centered
              >
                {{ props.row.updatedOn | formatDate }}
              </b-table-column>

              <b-table-column
                field="published"
                label="Status"
                centered
              >
                {{ props.row.published ? 'Publicado': 'Aguardando Aprovação' }}
              </b-table-column>

              <b-table-column
                fields="id"
                label="Ações"
                width="150"
              >
                <b-button
                  type="is-danger"
                  @click="confirmDelete(props.row.id)"
                  class="mr-2"
                >
                  <b-tooltip label="Apagar">
                    <b-icon icon="delete" />
                  </b-tooltip>
                </b-button>
                <b-button @click="editPost(props.row.id)">
                  <b-tooltip label="Editar">
                    <b-icon icon="square-edit-outline" />
                  </b-tooltip>
                </b-button>
              </b-table-column>

            </template>
          </b-table>

          <!--- Paginated Table End -->
        </b-collapse>
      </section>
    </div>
    <PremiumOnly v-else />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br'
import PremiumOnly from '@/components/PremiumOnly'
import { trimLengthMixin, formatDateMixin } from '@/mixins/filters'
// eslint-disable-next-line no-unused-vars
import * as firebase from 'firebase/app'
import { storage, postsCollection, premiumUsersCollection } from '../../firebaseConfig'
import md5 from 'md5'
import { ValidationProvider, ValidationObserver, setInteractionMode } from 'vee-validate'
import specialties from '../../utils/specialties'

setInteractionMode('passive')

const DEBUG = process.env.NODE_ENV === 'development'

export default {
  components: {
    ckeditor: CKEditor.component,
    PremiumOnly,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [trimLengthMixin, formatDateMixin],
  data () {
    return {
      filteredTags: [],
      imageData: null,
      imagePreview: null,
      uploadValue: 0,
      performingRequest: false,
      currentPage: 1,
      specialties,
      isPremium: false,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ['heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', 'tabletoolbar', '|', 'link', 'mediaEmbed', 'undo', 'redo'],
        language: 'pt-br',
        mediaEmbed: {
          previewsInData: true
        }
      },
      editingPost: false,
      post: {
        picture: null,
        title: '',
        content: '',
        specialties: []
      }
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'posts'])
  },
  async mounted () {
    this.localProfessionalProfile = this.professionalProfile
    this.performingRequest = true
    this.isPremium = await this.checkPremiumStatus(this.currentUser.uid)
    this.performingRequest = false
  },
  methods: {
    async checkPremiumStatus (userId) {
      const doc =
        await premiumUsersCollection
          .doc(userId)
          .get()

      return doc.exists
    },
    previewImage (file) {
      if (!file.name.includes('.') || file.size === 0) {
        this.file = null
        return this.$toasted.error('Por favor, adicione um arquivo válido')
      } else {
        this.uploadValue = 0
        this.imageData = file
        this.post.picture = null

        const reader = new FileReader()

        reader.onload = (e) => {
          this.imagePreview = e.target.result
        }

        reader.readAsDataURL(file)
      }
    },
    getFilteredTags (text) {
      this.filteredTags = this.specialties.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .includes(text.toLowerCase())
        )
      })
    },
    uploadPostPicture () {
      this.performingRequest = true

      const storageRef = storage.ref(`${this.currentUser.uid}/blog/${this.imageData.name}`).put(this.imageData)

      storageRef.on('state_changed', snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      },
      error => {
        this.performingRequest = false
        DEBUG && console.log(error.message)
      },
      () => {
        this.uploadValue = 100
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.post.picture = url
          this.performingRequest = false
          this.$toasted.success('Imagem enviada com sucesso!')
        })
      }
      )
    },
    getUserPosts () {

    },
    async validateBeforeSubmit () {
      const isValid = await this.$refs.postFormObserver.validate()

      isValid
        ? (this.editingPost ? this.updatePost() : this.createPost())
        : this.$toasted.error('Não foi possível criar o post. Verifique os dados e tente novamente')
    },
    createPost () {
      const TIMESTAMP = firebase.firestore.Timestamp
      const postId = md5(TIMESTAMP.now().nanoseconds.toString() + this.currentUser.uid.toString())

      this.performingRequest = true
      postsCollection.doc(postId).set({
        ...this.post,
        createdOn: TIMESTAMP.now().toDate(),
        picture: this.post.picture,
        title: this.post.title,
        content: this.post.content,
        userId: this.currentUser.uid,
        published: false,
        id: postId,
        author: {
          name: this.userProfile.name || '',
          lastName: this.userProfile.lastName || '',
          picture: this.userProfile.profilePictureUrl || ''
        },
        comments: 0,
        likes: 0
      }).then(() => {
        this.performingRequest = false
        this.$toasted.success('Post criado com sucesso!')
        this.post.content = ''
      }).catch(err => {
        this.performingRequest = false
        DEBUG && console.log(err)
      })
    },
    updatePost () {
      if (!this.post.id) {
        return
      }
      this.performingRequest = true
      postsCollection.doc(this.post.id).update({
        ...this.post,
        picture: this.post.picture || '',
        published: false,
        author: {
          name: this.userProfile.name || '',
          lastName: this.userProfile.lastName || '',
          picture: this.userProfile.profilePictureUrl || ''
        },
        updatedOn: new Date()
      })
        .then(() => {
          this.performingRequest = false
          this.$toasted.success('Post atualizado com sucesso!')
        })
        .catch(err => {
          this.performingRequest = false
          DEBUG && console.log(err)
        })
    },
    confirmDelete (id) {
      this.$buefy.dialog.confirm({
        message: 'Deseja apagar este post?',
        onConfirm: () => this.deletePost(id)
      })
    },
    async deletePost (id) {
      try {
        this.performingRequest = true
        await postsCollection.doc(id).delete()
        this.performingRequest = false
        this.$toasted.success('Post removido com sucesso')
      } catch (error) {
        this.$toasted.error('Um erro ocorreu')
        DEBUG && console.error(error)
      }
    },
    editPost (id) {
      this.performingRequest = true
      this.post = {
        ...this.posts.find(post => {
          return post.id === id
        })
      }
      this.editingPost = true
      this.performingRequest = false
    },
    cancelEditPost () {
      this.editingPost = false
      this.post.title = ''
      this.post.content = ''
      this.post.picture = ''
    }
  }
}

/* @todo
- Permitir que usuário possa apagar Post
- Ao alterar a imagem de perfil mostrar o arquivo carregado
- Ao alterar a imagem de perfil, atualizar as referencias a imagem de perfil nos posts do usuário
*/
</script>

<style scoped="">
img.preview {
  width: 200px;
}
</style>
